import { ErrorHandler, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CookieService } from 'ngx-cookie-service';

import { LoaderComponent } from './components/loader/loader.component';
import { LoginComponent } from './components/login/login.component';
import { NavComponent } from './components/nav/nav.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { httpInterceptorProviders } from './interceptors';
import { SharedModule } from '../shared/shared.module';
import { GlobalErrorHandler } from './services/global-error-handler.service';

@NgModule({
  imports: [CommonModule, RouterModule, SharedModule, FontAwesomeModule],
  declarations: [LoaderComponent, LoginComponent, NavComponent, PageNotFoundComponent],
  providers: [CookieService, httpInterceptorProviders, { provide: ErrorHandler, useClass: GlobalErrorHandler }],
  exports: [LoaderComponent, LoginComponent, NavComponent, PageNotFoundComponent]
})
export class CoreModule {}
